import React from "react";

// Small line icons for the Industry Audit panel. They take their colour from
// the text colour (className), so the theme decides purple or grey.

export function TickIcon({ className, label }) {
  return (
    <svg viewBox="0 0 20 20" className={className} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : "true"}>
      <circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6.25 10.25l2.5 2.5 5-5.25" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LockIcon({ className }) {
  return (
    <svg viewBox="0 0 20 20" className={className} aria-hidden="true">
      <rect x="4.5" y="9" width="11" height="8" rx="1.75" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M7 9V6.75a3 3 0 0 1 6 0V9" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
